import { useTranslation } from 'next-i18next';
import './tracking/events.quiz-school-pricing';
import { trackEvent } from '@zep/logger/tracking';
import { ChevronRightIcon } from '@/icons';
import { useCountryCode, useInquiryUrl } from '@/shared/hooks';
import { Button } from '@/ui_v3';
export const BulkAdoptionBanner = () => {
  const {
    t
  } = useTranslation(['common', 'pricing']);
  const {
    isKR
  } = useCountryCode();
  const {
    openInquiryUrl
  } = useInquiryUrl({
    krUrl: '/embed/sales?type=inquiry',
    source: 'pricing'
  });
  return <section className="bg-strong-alternative px-md py-xl mobile-lg:px-lg tablet-lg:px-2xl" data-sentry-component="BulkAdoptionBanner" data-sentry-source-file="BulkAdoptionBanner.tsx">
      <div className="mx-auto flex w-full max-w-[1000px] items-center gap-sm">
        <img className="hidden w-[120px] mobile-lg:inline" src="/assets/teacher_inquiry.webp" alt="Bulk Adoption Inquiry" />
        <div className="flex w-full flex-col items-center gap-md mobile-lg:items-start tablet-sm:flex-row tablet-sm:items-center tablet-sm:justify-between tablet-sm:gap-sm">
          <div className="flex flex-col gap-2xs text-center mobile-lg:text-left">
            <h3 className="text-heading-md-bold min-[750px]:text-heading-lg-extrabold">
              {isKR ? t('pricing:bulkAdoption.title') : t('pricing:bulkAdoption.global.title')}
            </h3>
            <p className="text-body-lg-semibold text-neutral">
              {t('pricing:bulkAdoption.description')}
            </p>
          </div>
          <Button variant="outlined" intent="alternative" size="lg" rightSlot={<ChevronRightIcon size="md" />} onClick={() => {
          void openInquiryUrl({
            location: 'pricing_bulk_adoption_banner',
            onInquiryClick: tracking_id => trackEvent('click_bulk_deal_inquiry', {
              tracking_id
            })
          });
        }} data-sentry-element="Button" data-sentry-source-file="BulkAdoptionBanner.tsx">
            {t('pricing:bulkAdoption.button')}
          </Button>
        </div>
      </div>
    </section>;
};